import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

const reports = accountId => ({
  parentNav: 'reports',
  routes: [
    'account_overview_reports',
    'conversation_reports',
    'csat_reports',
    'bot_reports',
    'agent_reports',
    'label_reports',
    'inbox_reports',
    'team_reports',
    'sla_reports',
    'contacts_and_conversations',
    'advanced_reports',
    'contacts_reports',
    'billing_reports',
    'conversations_reports',
    'basic_reports',
    'customs_reports'

  ],
  menuItems: [
    {
      icon: 'arrow-trending-lines',
      label: 'REPORTS_OVERVIEW',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/overview`),
      toStateName: 'account_overview_reports'

    },

    {
      icon: 'document-list-clock',
      label: 'BASIC_REPORTS',
      hasSubMenu: true,
      featureFlag: FEATURE_FLAGS.BASIC_REPORTS,
      toState: frontendURL(`accounts/${accountId}/reports/basic_reports`),
      toStateName: 'basic_reports',
      children: [
        {
          parent: "reports",
          icon: 'chat',
          label: 'REPORTS_CONVERSATION',
          hasSubMenu: false,
          toState: frontendURL(`accounts/${accountId}/reports/conversation`),
          toStateName: 'conversation_reports',
        },


        {
          parent: "reports",
          icon: 'emoji',
          label: 'CSAT',
          hasSubMenu: false,
          toState: frontendURL(`accounts/${accountId}/reports/csat`),
          toStateName: 'csat_reports',
        },
        // {
        //   parent: "reports",
        //   icon: 'bot',
        //   label: 'REPORTS_BOT',
        //   hasSubMenu: false,
        //   featureFlag: FEATURE_FLAGS.RESPONSE_BOT,
        //   toState: frontendURL(`accounts/${accountId}/reports/bot`),
        //   toStateName: 'bot_reports',
        // },
        {
          parent: "reports",
          icon: 'people',
          label: 'REPORTS_AGENT',
          hasSubMenu: false,
          toState: frontendURL(`accounts/${accountId}/reports/agent`),
          toStateName: 'agent_reports',
        },
        {
          parent: "reports",
          icon: 'tag',
          label: 'REPORTS_LABEL',
          hasSubMenu: false,
          toState: frontendURL(`accounts/${accountId}/reports/label`),
          toStateName: 'label_reports',
        },
        {
          parent: "reports",
          icon: 'mail-inbox-all',
          label: 'REPORTS_INBOX',
          hasSubMenu: false,
          toState: frontendURL(`accounts/${accountId}/reports/inboxes`),
          toStateName: 'inbox_reports',
        }
        //{
        //  parent: "reports",
        //  icon: 'people-team',
        //  label: 'REPORTS_TEAM',
        //  hasSubMenu: false,
        //  toState: frontendURL(`accounts/${accountId}/reports/teams`),
        //  toStateName: 'team_reports',
        //}
        // {
        //   parent: "reports",
        //   icon: 'document-list-clock',
        //   label: 'REPORTS_SLA',
        //   hasSubMenu: false,
        //   featureFlag: FEATURE_FLAGS.SLA,
        //   toState: frontendURL(`accounts/${accountId}/reports/sla`),
        //   toStateName: 'sla_reports',
        // }
      ]
    }
    ,
    {
      icon: 'document-list-clock',
      label: 'ADVANCED_REPORTS',
      hasSubMenu: true,
      featureFlag: FEATURE_FLAGS.ADVANCED_REPORTS,
      toState: frontendURL(`accounts/${accountId}/reports/advanced_reports`),
      toStateName: 'advanced_reports',
      children: [
        {
          parent: "reports",
          icon: 'arrow-trending-lines',
          label: 'CONTACTS_REPORTS',
          hasSubMenu: false,
          toState: frontendURL(`accounts/${accountId}/reports/contacts_reports`),
          toStateName: 'contacts_reports',
        },
        {
          parent: "reports",
          icon: 'arrow-trending-lines',
          label: 'CONVERSATIONS_REPORTS',
          hasSubMenu: false,
          toState: frontendURL(`accounts/${accountId}/reports/conversations_reports`),
          toStateName: 'conversations_reports',
        }
        ,
        {
          parent: "reports",
          icon: 'arrow-trending-lines',
          label: 'BILLING_REPORTS',
          hasSubMenu: false,
          toState: frontendURL(`accounts/${accountId}/reports/billing_reports`),
          toStateName: 'billing_reports',
        }
        ,
        {
          parent: "reports",
          icon: 'arrow-trending-lines',
          label: 'CUSTOMS_REPORTS',
          hasSubMenu: false,
          toState: frontendURL(`accounts/${accountId}/reports/customs_reports`),
          toStateName: 'customs_reports',
        }

      ]
    },



    {
      parent: "reports",
      icon: 'document-list-clock',
      label: 'REPORTS_CONTACTS_CONVERSATION',
      hasSubMenu: false,
      featureFlag: FEATURE_FLAGS.CONTACTS_AND_CONVERSATIONS,
      toState: frontendURL(`accounts/${accountId}/reports/contacts-and-conversations`),
      toStateName: 'contacts_and_conversations',
    }
  ],
});

export default reports;
